import React, {PureComponent} from 'react';
import styled from 'styled-components';
import CircularProgressbar from 'react-circular-progressbar';
import ContentEditable from 'react-contenteditable';
import SelectPicksConten from './SelectPicksConten';
import EstheticianNodeModel from './EstheticianNodeModel';

import Api from '../../utils/api';
import HttpUtils from '../../utils/http';

class CustomerProduct extends PureComponent {
    constructor(props){
        super(props);

        this.state = {
            selected: false,
            productInput: '',
            scoreInput: '',
            recReasonInput: '',
            recReasonEditable: false,
            editHtml: '',
            isOpen:false,
            es_in_no:false,
            estheticianNodeValue: this.props.estheticianPickNote ? this.props.estheticianPickNote :'',
            picksText: this.props.estheticianPick ? 'Esthetician’s pick': 'None',
            goodsAddNode:'true',
            estheticianPick: this.props.estheticianPick
        };

        this.handleSelectProduct = this.handleSelectProduct.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleDescriptionInputChange = this.handleDescriptionInputChange.bind(this);
        this.handleRecReasonTextInput = this.handleRecReasonTextInput.bind(this);
        this.saveRecReason = this.saveRecReason.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleOpen = this.handleOpen.bind(this);
        this.handleEsInOpen = this.handleEsInOpen.bind(this);
        this.handleChangePicks = this.handleChangePicks.bind(this);
        this.handleEditNoteEdit = this.handleEditNoteEdit.bind(this);
        this.fun_submitDataServer = this.fun_submitDataServer.bind(this);
        this.handleUpdateProductInputChange = this.handleUpdateProductInputChange.bind(this);
        this.handlePickSubmitChangeData = this.handlePickSubmitChangeData.bind(this);
    }

    componentDidMount() {
        this.renderRecReason();
    }


    componentDidUpdate(prevProps, prevState) {
        const prodId = this.props.id;
        if (!this.props.additionalReco) {
            if (this.props.currentRecoId === prodId) {
                this.setState({ selected: true });
            } else if (this.props.currentRecoId !== prodId) {
                this.setState({ selected: false });
            }
        } else {
            if (this.props.expandedRecoId === prodId) {
                this.setState({ selected: true });
            } else if (this.props.expandedRecoId !== prodId) {
                this.setState({ selected: false });
            }
        }

        if (prevProps.rowSelected !== this.props.rowSelected) {
            this.props.getIdOfCurrentRecos(0, 0);
            this.props.getIdOfExpandedRecos(0, 0);
        }



    }

    renderRecReason() {
        let recReasonListItemsStr = [];
        const reg = /<[a-z][\s\S]*>/i.test(this.props.recReason);
        
        if (!reg) {
            this.props.recReason.split(".").filter(str => { return str !== "" }).forEach((sentence, index, arr) => {
                const isDontKnow = sentence.toLowerCase().includes("dont know");
                if (!isDontKnow) {
                    if (index === arr.length - 1){
                        recReasonListItemsStr.push(`<li>${ sentence }</li>`);
                    } 
                    else recReasonListItemsStr.push(`<li>${ sentence + "." }</li>`);
                }
            });
            let recReasonOutputStr = `<ul>${ recReasonListItemsStr.toString().replace(",","").replace(/,/g, '').trim() }</ul>`;
            this.setState({ editHtml: recReasonOutputStr });
        } else {
            this.setState({ editHtml: this.props.recReason });
        }
        
    }

    handleSelectProduct(e) {
        if (this.props.rowSelected && !this.props.additionalReco) {
            if ((this.props.currentRecoId === this.props.id)) {
                    this.props.getIdOfCurrentRecos(0, 0);
            } else {
                const prodId = this.props.id;
                const prodScore = this.props.score;
                this.props.getIdOfCurrentRecos(prodId, prodScore);
            }
            
        } else if (this.props.rowSelected && this.props.additionalReco) {
            if ((this.props.expandedRecoId === this.props.id)) {
                    this.props.getIdOfExpandedRecos(0, 0);
                }
            else {
                const prodId = this.props.id;
                const prodScore = this.props.score;
                this.props.getIdOfExpandedRecos(prodId, prodScore);
            }
        }
    }

    handleRecReasonTextInput(e) {
        if (this.props.rowSelected) {
            this.setState({ recReasonEditable: true });
        }
    }

    handleInputChange(e) {
        e.preventDefault();
        e.stopPropagation();

        const re = /^[0-9\b]+$/;

        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({ [e.target.name]: e.target.value });
            if (e.target.name === "productInput") this.props.handleProductInputChange(e.target.value);
            else this.props.getScoreOfInputProduct(e.target.value);
        }
    }

    handleDescriptionInputChange(e) {
        this.setState({ editHtml: e.target.value });
    }

    saveRecReason() {
        const userId = this.props.userId;
        const productId = this.props.id;
        const productType = this.props.type;
        const reason = this.state.editHtml;

        const url = "/api/recommendation-reasons";

        fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            },
            body: JSON.stringify({
                userId: userId,
                productId: productId,
                productType: productType,
                reason: reason
            })
        }).then(response => {
            if (response.status === 200 || response.status === 201) {
                this.setState({ recReasonEditable: false });
                this.props.updateAfterChange();
                let reasonIds = [];
                if (localStorage.getItem('updated_reason_ids')) {
                    if (Array.isArray(localStorage.getItem('updated_reason_ids'))) reasonIds = localStorage.getItem('updated_reason_ids');
                    else reasonIds.push(localStorage.getItem('updated_reason_ids'));
                }
                reasonIds.push(this.props.id);
                localStorage.setItem('updated_reason_ids', reasonIds);
            } else {
                alert("There was a problem saving your input. Please try again.");
            }
        });
    }

    handleSubmit(e) {
        e.preventDefault();

        if (this.state.scoreInput === '' || this.state.scoreInput.length === 0) {
            alert('Matching score is required for editing product recommendations. Please enter a score.');
            return;
        }

        this.props.replaceProductArray(this.state.update_isEstheticianPick,this.state.update_estheticianNodeValue);
    }

    handleOpen(){
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    handleEsInOpen(){
        this.setState({
            es_in_no: !this.state.es_in_no
        });
    }

    handleChangePicks(type,text){
        this.setState({
            picksText:text,
            isOpen:false,
        },()=>{         
            if(type == "estheticians"){
                this.fun_submitDataServer(true)
            }else{
                this.fun_submitDataServer(false)
            }
        });
    }

    handleEditNoteEdit(e) {
        let name = e.target.name;
        let value = e.target.value;
        this.setState({ [name]: value },()=>{
            if(name == "goodsAddNode" && value == "false"){
                this.setState({estheticianNodeValue:''});
                this.handleChangePicks('estheticians','Esthetician’s pick')
            }
        });
    }

    handleUpdateProductInputChange(update_isEstheticianPick,update_estheticianNodeValue){
        this.setState({
            update_isEstheticianPick:update_isEstheticianPick,
            update_estheticianNodeValue:update_estheticianNodeValue,
        });
    }

    fun_submitDataServer(isEstheticianPick){
        const userId = this.props.userId;
        const productId = this.props.id;
        let estheticianNodeValue = this.state.estheticianNodeValue;

        HttpUtils.post("/api/portal-esthetician-picks",{
            userId: userId,
            productId: productId,
            note:estheticianNodeValue,
            isEstheticianPick:isEstheticianPick,
        }).then(()=>{
            this.setState({
                estheticianNodeValue: estheticianNodeValue
            });
        })
    }

    handlePickSubmitChangeData(isEstheticianPick,note){
        let picksText = 'None';
        if(isEstheticianPick == true){
            picksText = 'Esthetician’s pick';
        }
        this.setState({
            picksText:picksText,
            estheticianNodeValue:note,
            isOpen:false,
        });
    }

    render() {
        let ProductScore = styled.div`
        display: flex;
        flex-direction: column;
        `;
        return (
                <div className="user-product-container" >
                    {
                        this.props.rowSelected && this.state.selected ?
                        <div className="delete-button-container" onClick={ this.props.openDeleteModal } style={{backgroundColor: '#9b9b9b'}} >
                            {/* <FaTimesCircle size={24} color="#9b9b9b" className="delete-product-button" /> */}
                                <i className="fa fa-times" aria-hidden="true" style={{ color: '#fff', marginLeft: '4px',fontSize: '14px', marginTop: '2px'}}></i>
                        </div>
                        : null
                    }
                    <div className="es-picks-area">
                    {/* esthe_pick_type */}
                    {/* helloAva_pick_type */}
                    {
                        this.state.estheticianNodeValue !=null && this.state.estheticianNodeValue != '' ? <EstheticianNodeModel handlePickSubmitChangeData={this.handlePickSubmitChangeData} userId={this.props.userId} id={this.props.id} estheticianNodeValue={this.state.estheticianNodeValue}/>
                        : 
                        <div className={this.state.picksText == 'Esthetician’s pick' ? 'es-picks-area-title-label esthe_pick_type': 'es-picks-area-title-label' } onClick={this.handleOpen}>
                            {
                                this.state.estheticianNodeValue !=null && this.state.estheticianNodeValue != '' ? <img className="dialogue-img" src="../../../images/explain/icont/dialogue.png"/>:null
                            }
                            <span>{this.state.picksText}</span>
                           <i className={this.state.isOpen ? "fa fa-angle-up fa-fw fa-arrea" : "fa fa-angle-down fa-fw fa-arrea"} ></i>
                        </div>
                    }

                        
                         {
                             this.state.isOpen? 
                             <ul className="es-picks-area-select">
                                <li onClick={()=>{ this.handleChangePicks('none','None') }} >None</li>
                                <li className={this.state.es_in_no ? "est-pick-open" : null } >
                                    <span onClick={this.handleEsInOpen}>Esthetician’s pick</span>
                                    <div className="inputNode_area" style={this.state.es_in_no ? {display:'block'}:{display:'none'}}>
                                        <label>
                                            <input onChange={this.handleEditNoteEdit} checked={ this.state.goodsAddNode == 'false' ? true : false } type="radio" name="goodsAddNode" value='false' ></input>
                                            No notes
                                        </label>
                                        <label>
                                            <input onChange={this.handleEditNoteEdit} checked={ this.state.goodsAddNode == 'true' ? true : false }  type="radio" name="goodsAddNode" value='true'></input>
                                            Add notes
                                        </label>
                                        <div style={this.state.goodsAddNode == 'true' ? {display:'block'}:{display:'none'} }>
                                            <textarea onChange={this.handleEditNoteEdit} name="estheticianNodeValue" value={this.state.estheticianNodeValue} className="inputNode_area_textArea paragraphRegular4"></textarea>
                                            <button className="inputNode_area_button" onClick={()=>{ this.handleChangePicks('estheticians','Esthetician’s pick') }}>Save</button>
                                        </div>
                                    </div>
                                    <i className="solid-est"/>
                                </li>
                            </ul>:null
                         }
                         
                    </div>

                    <div style={this.props.rowSelected ? { cursor:"pointer" } : null} className={ this.state.selected ? "user-product editing" : "user-product" } onClick={ this.handleSelectProduct } >
                        {/* <ProductScore>
                            <div className="product-score">
                                <CircularProgressbar
                                  percentage={this.props.score}
                                  strokeWidth={5}
                                  textForPercentage={null}
                                  styles={{
                                    path: { stroke: `rgba(255, 173, 148, ${this.props.score / 100})` },
                                  }}
                                  counterClockwise={true}
                                />
                                <div className="product-score-label">
                                    <div className="number">{this.props.score}</div>
                                    <div className="matching-score">matching score</div>
                                </div>
                            </div>
                        </ProductScore> */}

                        <div className="product-score-new">
                            <div className="product-score-label">
                                <div className="number">{this.props.score}</div>
                                <div className="matching-score">MATCH</div>
                            </div>
                        </div>



                        <div className="product-info product-image"><img alt={ this.props.name } src={ this.props.image } /></div>
                        <div className="product-info-group">
                            <div className="product-info product-price">{ '$' + this.props.price.slice(0,-2) }</div>
                            <div className="product-info product-name">{ this.props.name }</div>
                            <div className="product-info product-id">Product id: <span>{ this.props.id }</span></div>
                            <div className="product-info product-why">Why is it good?</div>
                        </div>
                        <div className="product-recreason">
                            <div className="recreason-box" onClick={ this.handleRecReasonTextInput } >
                           
                                <div className="text-and-save">
                                    <ContentEditable
                                        html={ this.state.editHtml }
                                        disabled={ !this.state.recReasonEditable }
                                        onChange={ this.handleDescriptionInputChange } 
                                    />
                                </div>
                            
                            </div>
                        </div>
                        { this.state.recReasonEditable ? <button onClick={ this.saveRecReason } >Save</button> : null }
                    </div> 
                    {
                            
                        this.state.selected && !this.props.additionalReco ?
                        <div className="edit-section">
                            <div className="change-to">Change to</div>
                            <div className="input-confirm">
                                <h5>Product ID</h5>
                                <input type="number" name="productInput" value={ this.state.productInput } onChange={ this.handleInputChange } />
                                <h5>Score</h5>
                                <input type="number" maxLength="2" name="scoreInput" value={ this.state.scoreInput } onChange={ this.handleInputChange } />
                                <SelectPicksConten handleUpdateProductInputChange={this.handleUpdateProductInputChange}></SelectPicksConten>
                                <div className="input-confirm-button" >
                                    <button onClick={ this.handleSubmit } >Confirm</button>
                                </div>
                            </div>
                        </div> :
                        null
                    }
                </div>
        );
    }
}

export default CustomerProduct;



// WEBPACK FOOTER //
// ./src/components/customersuccessportal/CustomerProduct.js